type Unit = 'px' | 'rem' | 'em' | '%' | 'vw' | 'vh' | 'ch';
type Calc = `calc(${string})`;
type SizingAttributes =
  | 'max-content'
  | 'contain'
  | 'inherit'
  | 'cover'
  | 'auto';
export type CustomSpacingAndSizingUnit =
  | `${string}${Unit}`
  | Calc
  | SizingAttributes;

export const customSpacingAndSizing = (value: CustomSpacingAndSizingUnit) =>
  value;
